
















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateUserChannel } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import Rules from '@/utils/rules'
import { getByParentId } from '@/store/classifyStore'
import { VImageUpload } from '@/components/upload'

@Component({
  components: {
    VImageUpload,
  },
})
export default class CreateChannelDialog extends Vue {
  private show = false
  private data = {}
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    channelNo: [this.requiredRule],
    channelName: [this.requiredRule],
  }

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {}
  }
  public open() {
    this.show = true
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      await CreateUserChannel(this.data)
      Message.success('保存')
      this.close()
    })
  }
}
